import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, Validators } from '@angular/forms';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-editflowbirdconfig',
    templateUrl: './editflowbirdconfig.component.html',
    styleUrls: ['./editflowbirdconfig.component.scss'],
    standalone: false
})
export class EditFlowbirdConfigComponent extends ModelEditor implements OnInit {
  private destroy$ = new Subject<void>();

  constructor(
    private injector: Injector, 
  ) {
    super("integrations/flowbird/configurations", injector);
    this.parentRoute.params
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => { this.ModelId = params['id']; });
  }

  public override BeforeSave(): void {
    return;
  }

  public override DefaultModel(): any {
    return {
      Name: "",
      Description: "",
      Url: "https://api.flowbird.com/",
      Username: "",
      Password: "",
      ImportScheduleMinutes: 15,
      TerminalMappings: []
    }
  }

  public override Validators(): any {
    return {
      Url: [Validators.maxLength(200), Validators.minLength(1), Validators.required],
      Name: [Validators.maxLength(100), Validators.minLength(1), Validators.required],
      Username: [Validators.maxLength(100), Validators.required],
      Password: [Validators.maxLength(100)],
      Description: [Validators.maxLength(500)],
      ImportScheduleMinutes: [Validators.required, Validators.min(1)],
      'TerminalMappings.TerminalId': [Validators.required, Validators.maxLength(100)],
      'TerminalMappings.ParkingLotExternalId': [Validators.required, Validators.maxLength(100)]
    }
  }

  public override AfterModelLoaded(): void {
    // Password is not returned from API for security, so add the control manually
    if (!this.Form.get('Password')) {
      this.Form.addControl('Password', new UntypedFormControl('', [Validators.maxLength(100)]));
    }
  }

  public get TerminalMappingsArray(): UntypedFormArray {
    return this.FormArray(this.Form, 'TerminalMappings');
  }

  public AddTerminalMapping(): void {
    this.AddToFormArray(this.TerminalMappingsArray, {
      Id: null,
      TerminalId: '',
      ParkingLotExternalId: ''
    }, 'TerminalMappings');
  }

  public RemoveTerminalMapping(index: number): void {
    this.RemoveFromFormArray(this.TerminalMappingsArray, index);
  }

  ngOnDestroy() : void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

